/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="97.32" height="95.58" viewBox="0 0 97.32 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M111,33a1.25,1.25,0,0,1,1.24,1.12V68.31A1.25,1.25,0,0,1,111,69.56a1.27,1.27,0,0,1-1.25-1.13V35.51H99.1v10A1.25,1.25,0,0,1,98,46.78h-.13a1.26,1.26,0,0,1-1.25-1.12V34.26A1.24,1.24,0,0,1,97.72,33H111Z" transform="translate(-28 -30)" fill="#0e497b"/><path d="M42.35,54a1.24,1.24,0,0,1,1.24,1.12v52.82H69.18A1.26,1.26,0,0,1,70.43,109v.13a1.25,1.25,0,0,1-1.12,1.24h-27a1.25,1.25,0,0,1-1.24-1.13V55.2A1.25,1.25,0,0,1,42.35,54Z" transform="translate(-28 -30)" fill="#0e497b"/><g>
      <path d="M76,30.22a1.24,1.24,0,0,1,1.3-.07l.12.07,47.41,32.46a1.25,1.25,0,0,1-1.3,2.14l-.12-.07-46.7-32L30,64.75a1.26,1.26,0,0,1-1.66-.22l-.08-.11a1.24,1.24,0,0,1,.22-1.65l.1-.09Z" transform="translate(-28 -30)" fill="#0e497b"/>
      <path d="M94.88,67.2c-6.08,5.45-13.34,8.18-22.49,8.45a1.25,1.25,0,0,0-1.22,1.25v9.18c0,9.37,1,16.15,3.87,22.27,3.64,7.77,10.15,13.53,20.25,17.16a1.24,1.24,0,0,0,.85,0c10.09-3.63,16.6-9.39,20.25-17.16,2.87-6.12,3.86-12.89,3.86-22.27V76.9A1.24,1.24,0,0,0,119,75.65c-9.15-.27-16.41-3-22.49-8.45A1.24,1.24,0,0,0,94.88,67.2Zm.83,2.58.41.34c5.86,4.81,12.74,7.4,21,7.94l.59,0v8c0,9-.94,15.49-3.63,21.21l-.19.4c-3.26,6.69-8.88,11.72-17.57,15.07l-.65.24.43.16c-9.49-3.41-15.48-8.71-18.84-15.87l-.2-.44c-2.53-5.61-3.43-12-3.43-20.77v-8l.59,0c8.31-.54,15.19-3.13,21-7.94Z" transform="translate(-28 -30)" fill="#0e497b"/>
      <polygon points="78.24 56.75 80.36 58.87 64.98 74.25 55.07 64.34 57.19 62.22 64.98 70.01 78.24 56.75" fill="#ffb81c"/>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'HouseWithCheckmarkShieldIcon';

export default Icon;
